import React, { FC, Suspense, useRef } from 'react';
import { T } from 'src/shared/helpers';
import { useSubscriptionData } from 'src/shared/hooks/useSubscriptionData';
import ServiceCredits from 'src/components/pages/myAccount/serviceCredits';
import { getVectorizeServiceConfig } from 'src/components/pages/myAccount/serviceCreditsConfigs';
import { Dialog } from '../dialog';
import Loader from '../loader';

/** Reuses the subscriptions page's activation, trial-credit and purchase flow. */
export const AgentVectorizerCreditsDialog: FC<{ onClose: () => void; onReady: () => void }> = ({ onClose, onReady }) => {
    const { subscription, ecommerceName, shopifyEcommerceSettings, sellerMarketplace } = useSubscriptionData();
    const completed = useRef(false);
    const ready = () => {
        if (completed.current) return;
        completed.current = true;
        onClose();
        onReady();
    };
    const isShopify = ecommerceName === 'SHOPIFY';
    const service = getVectorizeServiceConfig(
        {
            inTrial: subscription?.inTrial ?? false,
            isShopify,
            isTestStore: shopifyEcommerceSettings?.isTestStore ?? false
        },
        { hasTrialCredits: true }
    );
    return (
        <Dialog title={T._('AI Vectorizer', 'Admin')} onClose={onClose}>
            <Suspense fallback={<Loader />}>
                <ServiceCredits
                    services={[service]}
                    subscriptionCurrencyCode={subscription?.plan?.currencyCode ?? 'USD'}
                    isShopify={isShopify}
                    marketPlace={sellerMarketplace ?? undefined}
                    isAddonActive={subscription?.addons.some((addon) => addon.name === 'VECTORIZE')}
                    purchaseAutoRefill={false}
                    refreshCreditsOnOpen
                    returnUrlAfterApproval={window.location.href}
                    openApprovalInNewTab
                    onPurchaseCompleted={ready}
                    onCreditsRestored={ready}
                />
            </Suspense>
        </Dialog>
    );
};
